import { getGoogleAdsConsent } from 'utils/consent/googleAdsConsent';

import { SOURCE_DATA_SESSION_STORAGE_KEY, UTM_DATA_SESSION_STORAGE_KEY } from './keys';

export const getParsedItemFromSessionStorage = (key: string) => {
  const item = sessionStorage.getItem(key);
  return item ? JSON.parse(item) : item;
};

export const saveObjectToSessionStorage = (key: string, data: any) =>
  sessionStorage.setItem(key, JSON.stringify(data));

export const removeObjectFromSessionStorage = (key: string) => sessionStorage.removeItem(key);

export const removeInnerPropertyFromSessionStorage = (mainKey: string, keyToBeRemoved: string) => {
  const data = getParsedItemFromSessionStorage(mainKey);
  if (Object.prototype.hasOwnProperty.call(data, keyToBeRemoved)) {
    delete data[keyToBeRemoved];
    sessionStorage.setItem(mainKey, JSON.stringify(data));
  }
};

export const clearSession = () => sessionStorage.clear();

export const getUTMData = () => {
  const utmData = JSON.parse(sessionStorage.getItem(UTM_DATA_SESSION_STORAGE_KEY) ?? '{}');
  return utmData;
};

// Merges the Google Ads click id into the stored UTM data without clobbering the other params.
// Used by the capture hook once Google Ads Remarketing consent is granted.
export const persistGclid = (gclid: string) => {
  const utmData = getUTMData();
  saveObjectToSessionStorage(UTM_DATA_SESSION_STORAGE_KEY, { ...utmData, bfs_gclid: gclid });
};

export const getUTMDataForApi = () => {
  const { bfs_gclid, ...rest } = getUTMData();
  // Only transmit the gclid while Google Ads Remarketing consent is still granted. Guarding on
  // bfs_gclid presence keeps every non-BFS tenant's payload unchanged.
  if (!bfs_gclid) {
    return rest;
  }
  return getGoogleAdsConsent() === true ? { ...rest, gclid: bfs_gclid } : rest;
};

export const getSourceData = () => {
  return JSON.parse(sessionStorage.getItem(SOURCE_DATA_SESSION_STORAGE_KEY) ?? '{}');
};
